import request from '@/base/service'

const requestC = (data) => {
  return request({
    ...data,
    ...{
      baseURL: process.env.VUE_APP_CALL
    }
  })
}
const requestS = (data) => {
  return request({
    ...data,
    ...{
      baseURL: process.env.VUE_APP_BASE_API_SCRM
    }
  })
}
// 获取部门及人员层级结构
export function getDepartUserStructure (data) {
  return requestS({
    url: '/common/getEmployeeTreeStructure',
    method: 'get',
    data
  })
}
// 跟进记录详情中的通话录音详情/录音播放、下载
export function getRecordingAddress (params) {
  return requestC({
    url: '/call/getRecordingAddress',
    method: 'get',
    params
  })
}
// 地区接通趋势
export function getAreaTrend (data) {
  return requestC({
    url: '/CallOutData/getAreaTrend',
    method: 'post',
    data
  })
}

// 日期接通趋势
export function getDateTrend (data) {
  return requestC({
    url: '/CallOutData/getDateTrend',
    method: 'post',
    data
  })
}

// 时段接通趋势
export function getTimeTrend (data) {
  return requestC({
    url: '/CallOutData/getTimeTrend',
    method: 'post',
    data
  })
}

// 今日汇总数据
export function getTodayAggregate (data) {
  return requestC({
    url: '/CallOutData/getTodayAggregate',
    method: 'get',
    data
  })
}

// 查询当前座席绑定员工列表
export function queryCallCenterClientUsers (data) {
  return requestC({
    url: '/callcenter/client/queryCallCenterClientUsers',
    method: 'post',
    data
  })
}
// 通话记录
export function getCallRecord (data) {
  return requestC({
    url: '/call/getCallRecord',
    method: 'post',
    data
  })
}

// 获取通话明细
export function getCallDetail (data) {
  return requestC({
    url: '/call/getCallDetail',
    method: 'post',
    data
  })
}

// 查询通话记录统计数
export function getCallRecordCount (data) {
  return requestC({
    url: '/call/getCallRecordCount',
    method: 'post',
    data
  })
}

// 模糊查询联系人名字
export function getContactNameByLike () {
  return requestS({
    url: '/feign/callcenter/getContactNameByLike',
    method: 'get'
  })
}

// 模糊查询客户名字
export function getCustomerNameByLike () {
  return requestS({
    url: '/feign/callcenter/getCustomerNameByLike',
    method: 'get'
  })
}

// 获取座席通话列表数据
export function getSeatsCallDataList (data) {
  return requestC({
    url: '/seatsCall/getSeatsCallDataList',
    method: 'post',
    data
  })
}

// 获取座席通话数据统计
export function getCountSeatsData (data) {
  return requestC({
    url: '/seatsCall/getCountSeatsData',
    method: 'post',
    data
  })
}

// 导出座席通话数据
export function exportSeatsData (data) {
  return requestC({
    url: '/seatsCall/exportSeatsData',
    method: 'post',
    responseType: 'blob',
    data
  })
}

export function exportVerifyErrorTemplate (params) {
  return requestC({
    url: '/callBatchManage/exportVerifyErrorTemplate',
    method: 'get',
    responseType: 'blob',
    params
  })
}

// 客户名称
export function queryScrmUsers (data) {
  return requestS({
    url: '/feign/callcenter/queryScrmUsers',
    method: 'post',
    data
  })
}
// 查询当前员工及下属员工接口
export function getUserIdsByCondition (data) {
  return requestS({
    url: '/feign/callcenter/getUserIdsByCondition',
    method: 'get',
    data
  })
}

// 部门下拉列表
export function getDepartTreeStructure (data) {
  return requestS({
    url: '/department/getDepartTreeStructure',
    method: 'get',
    data
  })
}

// 解绑用户席位
export function unbindClientUser (data) {
  return requestC({
    url: '/callcenter/client/unbindClientUser',
    method: 'post',
    data
  })
}
// 外呼创建跟进记录
export function createFollowup (data) {
  return requestS({
    url: '/followup/createFollowup',
    method: 'post',
    data
  })
}

// 呼叫明细导出
export function exportCallDetail (data) {
  return requestC({
    url: '/call/exportCallDetail',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 呼叫记录导出
export function exportCallRecord (data) {
  return requestC({
    url: '/call/exportCallRecord',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 外呼取消
export function callOutCancel (data) {
  return requestC({
    url: '/call/callOutCancel',
    method: 'get',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    params: data
  })
}

// v1.2-二期座席管理-查询当前用户座席列表
export function getCurrentAccountClients (data) {
  return requestC({
    url: '/callcenter/client/getCurrentAccountClients',
    method: 'post',
    data
  })
}
// v1.2-二期话机管理-查询话机
export function getExtens (data) {
  return requestC({
    url: '/extens/getExtens',
    method: 'post',
    data
  })
}
// v1.2-二期座席管理-用户新增座席
export function createClient (data) {
  return requestC({
    url: '/callcenter/client/createClient',
    method: 'post',
    data
  })
}
// v1.2-二期座席管理-编辑当前用户座席
export function editCurrentAccountClient (data) {
  return requestC({
    url: '/callcenter/client/editCurrentAccountClient',
    method: 'post',
    data
  })
}
// v1.2-二期座席管理-删除当前用户座席
export function deleteClient (data) {
  return requestC({
    url: '/callcenter/client/deleteClient',
    method: 'get',
    params: data
  })
}

// 获取当前可用外显号码列表
export function getExon (data) {
  return requestC({
    url: '/clidNumber/get',
    method: 'get',
    params: data
  })
}

// v2.6.4新增座席外显号码列表(选择号码)
export function getAearNumberList () {
  return requestC({
    url: '/clidNumber/getAreaNumberList',
    method: 'get'
  })
}
// 增加拨打次数
// export function addCountLead (data) {
//   return requestC({
//     url: `/customer/contact/addCount/${data.leadId}`,
//     method: 'post'
//   })
// }
// v1.2-二期话机管理-新增话机
export function createExten (data) {
  return requestC({
    url: '/extens/createExten',
    method: 'post',
    data
  })
}
// v1.2-二期话机管理-修改话机
export function updateExten (data) {
  return requestC({
    url: '/extens/updateExten',
    method: 'post',
    data
  })
}
// v1.2-二期话机管理-删除话机
export function deleteExten (data) {
  return requestC({
    url: '/extens/deleteExten',
    method: 'get',
    params: data
  })
}
// v1.2-二期座席管理-查询座席数量
export function getClientCount (data) {
  return requestC({
    url: '/callcenter/client/getClientCount',
    method: 'get',
    params: data
  })
}

// 根据手机号查询客户类型
export function getSource (data) {
  return requestS({
    url: '/feign/callcenter/getSource',
    method: 'get',
    params: data
  })
}

// v1.2-二期话机管理-根据话机类型查询分机或软电话
export function queryExtensByType (type) {
  return requestC({
    url: `/extens/queryExtensByType/${type}`,
    method: 'get'
    // params: data
  })
}

// v1.2-二期座席管理-查询当前席位信息
export function queryCurrentAccountClient (data) {
  return requestC({
    url: `/callcenter/client/queryCurrentAccountClient/${data.id}`,
    method: 'get',
    params: { supplierCode: data.supplierCode }
  })
}

// 通话追踪
export function tracking (data) {
  return requestC({
    url: '/call/tracking',
    method: 'get',
    params: data
  })
}

// 静音
export function mute (data) {
  return requestC({
    url: '/call/mute',
    method: 'get',
    params: data
  })
}
// 取消静音
export function unmute (data) {
  return requestC({
    url: '/call/unmute',
    method: 'get',
    params: data
  })
}
// v1.2-呼叫中心用户与供应商配置管理-获取当前用户外呼编号
export function querySupplierUserCallCode (data) {
  return requestC({
    url: '/callcenter/supplierUser/querySupplierUserCallCode',
    method: 'get',
    params: data
  })
}
// 增加拨打次数
export function addCountLead (data) {
  return requestS({
    url: `/customer/contact/addCount/${data.leadId}`,
    method: 'post'
  })
}

/// /////////////////////////////////////////////////外呼机器人接口
// 机器人v1.0-查询机器人任务列表
export function queryRobotTasks (data) {
  return requestC({
    url: '/callcenter/robot/queryRobotTasks',
    method: 'post',
    data
  })
}
// 机器人v1.0-查询外显号码组
export function queryRobotNumberStrategy (data) {
  return requestC({
    url: '/callcenter/robot/queryRobotNumberStrategy',
    method: 'get',
    params: data
  })
}
// 机器人v1.0-查询场景列表
export function queryRobotWorkflows (data) {
  return requestC({
    url: '/callcenter/robot/queryRobotWorkflows',
    method: 'get',
    params: data
  })
}
// 机器人v1.0-查询机器人列表
export function queryRobots (data) {
  return requestC({
    url: '/callcenter/robot/queryRobots',
    method: 'get',
    params: data
  })
}
// 机器人v1.0-查询工作时间策略
export function queryRobotWorkTimeStrategy (data) {
  return requestC({
    url: '/callcenter/robot/queryRobotWorkTimeStrategy',
    method: 'get',
    params: data
  })
}
// 机器人v1.0-导出机器人外呼用户电话号码模板
export function exportTemplate (data) {
  return requestC({
    url: '/callcenter/robot/exportTemplate',
    method: 'get',
    responseType: 'blob',
    data
  })
}
// 机器人v1.0-创建机器人任务
export function createRobotTask (data) {
  return requestC({
    url: '/callcenter/robot/createRobotTask',
    method: 'post',
    data
  })
}
// 机器人v1.0-编辑机器人任务详情
export function modifyRobotTaskDetail (data) {
  return requestC({
    url: '/callcenter/robot/modifyRobotTaskDetail',
    method: 'post',
    data
  })
}
// 机器人v1.0-删除任务
export function deleteRobotTask (taskId) {
  return requestC({
    url: `/callcenter/robot/deleteRobotTask/${taskId}`,
    method: 'get'
  })
}
// 机器人v1.0-查询任务详情
export function queryRobotTaskDetail (taskId) {
  return requestC({
    url: `/callcenter/robot/queryRobotTaskDetail/${taskId}`,
    method: 'get'
  })
}
// 机器人v1.0-复制任务
export function duplicateTask (data) {
  return requestC({
    url: '/callcenter/robot/duplicateTask',
    method: 'get',
    params: data
  })
}
// 机器人v1.0-暂停任务(只有启动中状态可暂停任务)
export function pauseRobotTask (taskId) {
  return requestC({
    url: `/callcenter/robot/pauseRobotTask/${taskId}`,
    method: 'post'
  })
}
// 机器人v1.0-启动任务(只有新建状态和暂停状态可启动任务)
export function startRobotTask (taskId) {
  return requestC({
    url: `/callcenter/robot/startRobotTask/${taskId}`,
    method: 'post'
  })
}
// 机器人v1.0-终止任务
export function stopRobotTask (taskId) {
  return requestC({
    url: `/callcenter/robot/stopRobotTask/${taskId}`,
    method: 'post'
  })
}
// 机器人v1.0-机器人任务呼出数据分析统计
export function calloutAnalysis (data) {
  return requestC({
    url: '/callcenter/robot/calloutAnalysis',
    method: 'get',
    params: data
  })
}
// 机器人v1.0-机器人任务呼出记录列表
export function queryRobotCallOutFlow (data) {
  return requestC({
    url: '/callcenter/robot/queryRobotCallOutFlow',
    method: 'post',
    data
  })
}
// 分配外呼员工
export function manualBindCallCenterUserClient (data) {
  return requestC({
    url: '/callcenter/client/manualBindCallCenterUserClient',
    method: 'get',
    params: data
  })
}
/// ///////////////////////////////////座席工作台////////////////////
// 分页查询工作台
export function searchPage (data) {
  return requestC({
    url: '/workbench/searchPage',
    method: 'post',
    data
  })
}
// 查询工作台筛选条件合计
export function searchConditionTotal (data) {
  return requestC({
    url: '/workbench/searchConditionTotal',
    method: 'post',
    data
  })
}
// 今日工作看板
export function todayWork (data) {
  return requestC({
    url: '/workbench/todayWork',
    method: 'get',
    params: data
  })
}
// 管理看板
export function manageWork (data) {
  return requestC({
    url: '/workbench/manageWork',
    method: 'get',
    params: data
  })
}
// 个人详情 http缓存 添加随机数
export function leadDetails (data) {
  return requestC({
    url: '/workbench/leadDetails?v=' + Math.random(),
    method: 'get',
    params: data
  })
}
// 编辑个人详情
export function editLeadDetails (data) {
  return requestC({
    url: '/workbench/editLeadDetails',
    method: 'post',
    data
  })
}
// 查询跟进记录
export function queryFollowRecordList (data) {
  return requestC({
    url: '/callLeadFollow/queryFollowRecordList',
    method: 'post',
    data
  })
}
// 添加跟进记录
export function addFollowRecord (data) {
  return requestC({
    url: '/callLeadFollow/addFollowRecord',
    method: 'post',
    data
  })
}
// 激活名单接口
export function activateLeads (data) {
  return requestC({
    url: '/dispatchLead/activateLeads',
    method: 'post',
    data
  })
}
// 批量分配线索名单
export function batchDispatchLead (data) {
  return requestC({
    url: '/dispatchLead/batchDispatchLead',
    method: 'post',
    data
  })
}
// 导出名单接口
export function exportLeadList (data) {
  return requestC({
    url: '/dispatchLead/exportLeadList',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 分配名单预览接口
export function getDispatchPreview (data) {
  return requestC({
    url: '/dispatchLead/getDispatchPreview',
    method: 'post',
    data
  })
}
// 归属人员下拉列表接口
export function getFollowerUserList (data) {
  return requestC({
    url: '/callUser/getFollowerUserList',
    method: 'get',
    data
  })
}
// 分配部门树结构包含今日分配
export function getTodayHasDispatched (data) {
  return requestC({
    url: '/dispatchLead/getTodayHasDispatched',
    method: 'get',
    data
  })
}
// 操作权限判断接口
export function isOptionUser (data) {
  return requestC({
    url: '/workbench/isOptionUser',
    method: 'get',
    data
  })
}
// /////////////////////2.6.1//////////////////////////////////////
// 批次管理-导入模板下载
export function batchExportTemplate (data) {
  return requestC({
    url: '/callBatchManage/exportTemplate',
    method: 'get',
    responseType: 'blob',
    data
  })
}
// 批次管理-导入数据
export function importTemplate (data) {
  return requestC({
    url: '/callBatchManage/importTemplate',
    method: 'post',
    data
  })
}
// 保存批次管理记录
export function saveBatchManage (data) {
  return requestC({
    url: '/callBatchManage/saveBatchManage',
    method: 'post',
    data
  })
}
// 查询批次管理不分页
export function searchList (data) {
  return requestC({
    url: '/callBatchManage/searchList',
    method: 'post',
    data
  })
}
// 分页查询批次管理
export function batchSearchPage (data) {
  return requestC({
    url: '/callBatchManage/searchPage',
    method: 'post',
    data
  })
}
// 查询来源渠道
export function queryClueSource (data) {
  return requestC({
    url: '/queryCriteria/queryClueSource',
    method: 'post',
    data
  })
}
// 管理工作台
export function managerSearchPage (data) {
  return requestC({
    url: '/managerPlatform/searchPage',
    method: 'post',
    data
  })
}
// 管理工作台 询工作台筛选条件合计
export function managerSearchConditionTotal (data) {
  return requestC({
    url: '/managerPlatform/searchConditionTotal',
    method: 'post',
    data
  })
}
// 获取管理工作台看板数据
export function getManagerWorkPlatformBoard (data) {
  return requestC({
    url: '/managerPlatform/getManagerWorkPlatformBoard',
    method: 'get',
    data
  })
}
// 获取坐席工作台看板数据
export function getSeatsWorkBoard (data) {
  return requestC({
    url: '/managerPlatform/getSeatsWorkBoard',
    method: 'get',
    data
  })
}
// 回收名单
export function recycleClueList (data) {
  return requestC({
    url: '/managerPlatform/recycleClueList',
    method: 'post',
    data
  })
}

// /////////////////////2.6.11//////////////////////////////////////

// 当前开通的供应商
export function getMultipleSupplierUser () {
  return requestC({
    url: '/callcenter/supplierUser/getMultipleSupplierUser',
    method: 'get'
  })
}
// 当前绑定坐席的供应商
export function queryMultipleSupplierClient () {
  return requestC({
    url: '/callcenter/supplierUser/queryMultipleSupplierClient',
    method: 'get'
  })
}

// /////////////////////2.6.11.3 新增融营供应商//////////////////////////////////////
// // 发送验证码接口
// export function validClientBindTel() {
//   return requestC({
//     url: '/callcenter/client/validClientBindTel',
//     method: 'post'
//   })
// }
// 验证接口
export function confirmValidClientBindTel (data) {
  return requestC({
    url: '/callcenter/client/confirmValidClientBindTel',
    method: 'post',
    data
  })
}

// 呼叫
export function callOut (data) {
  return requestC({
    url: '/call/callOut',
    method: 'post',
    data
  })
}
// 查询有效座席
export function queryCallCenterClient () {
  return requestC({
    url: '/callcenter/client/queryCallCenterClient',
    method: 'post',
    headers: { 'content-type': 'application/x-www-form-urlencoded' }
  })
}
// 验证席位绑定号码
export function validClientBindTel (data) {
  return requestC({
    url: '/callcenter/client/validClientBindTel',
    method: 'post',
    data
  })
}

// 设置席位信息
export function setCallCenterClient (data) {
  return requestC({
    url: '/callcenter/client/setCallCenterClient',
    method: 'post',
    data
  })
}
// 当前通话状态
export function getPresentCallStatus (params) {
  return requestC({
    url: '/call/getPresentCallStatus',
    method: 'get',
    params
  })
}
// 席位下线
export function offlineClient (params) {
  return requestC({
    url: '/callcenter/client/offlineClient',
    method: 'get',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    params
  })
}
// 获取当前用户席位信息
export function queryUserCallClient (params) {
  return requestC({
    url: '/callcenter/client/queryUserCallClient',
    method: 'get',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    params
  })
}
